@if (!failed && coins.length) {
<div class="border-y border-[var(--card-border-color)] bg-[var(--card-bg-color)]">
  <div class="mx-auto flex max-w-[1200px] items-center gap-[18px] overflow-x-auto px-2.5 py-[5px] text-[13px] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">

    <a class="whitespace-nowrap font-semibold text-[var(--text-color)]" [routerLink]="['/', r.currencies]">Курсы:</a>

    @for (coin of coins; track coin.id) {
      <a class="inline-flex items-baseline gap-[5px] whitespace-nowrap text-[var(--text-color)] no-underline [&:hover_.tick-price]:text-[var(--primary-color)]" [routerLink]="['/', r.currencies, coin.id]">
        <span class="text-xs font-bold text-[var(--text-color-gray)]">{{coin.symbol | uppercase}}</span>
        <span class="tick-price">{{coin.current_price | number:'1.0-2'}} ₽</span>
        <span class="text-[11px] font-semibold [&.up]:text-[var(--up-color)] [&.down]:text-[var(--down-color)]"
              [class.up]="(coin.price_change_percentage_24h ?? 0) >= 0"
              [class.down]="(coin.price_change_percentage_24h ?? 0) < 0">
          {{(coin.price_change_percentage_24h ?? 0) >= 0 ? '▲' : '▼'}}
          {{coin.price_change_percentage_24h | number:'1.1-2'}}%
        </span>
      </a>
    }

  </div>
</div>
}
